import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchAllPaymentReception = async () => {

        const { fetchAllPaymentReception } = FetchData
        
        fetchAllPaymentReception.executeFetch()

    }

    const handleClickFetchSpecificPaymentReception = async (idtransaction, flagFormOpeningMode) => {

        const { setFormOpeningMode } = globalStates
        const { FormScreen: {onResetForm} } = Forms

        const { fetchSpecificPaymentReception } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificPaymentReception

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idtransaction: idtransaction})
        executeFetch()

        handleClickShowForm(true)
        setFormOpeningMode(flagFormOpeningMode)

    }

    const handleChangeTypeTransaction = async (e) => {

        const { FormScreen } = Forms
        const { setFormState, } = FormScreen

        const { name, value } = e.target


        setFormState(prevState => ({
            ...prevState,
            // efectivo
            idcaja: '',
            deposito_observaciones: '',
            // deposito
            boleta_numero: '',
            idbanco: '',
            aprobacion_referencia_ach: '',
            aprobacion_check: '',
            aprobacion_observaciones: '',
            acceptedFiles: [],
            fileRejections: [],
            [ name ]: value
        }))
    }

    const handleChangeAmount = (event) => {
        const { FormScreen } = Forms
        const { formState, setFormState } = FormScreen

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_moneda !== '' && formState.movimiento_tipo_cambio !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: value,
                movimiento_moneda: formState.movimiento_moneda,
                movimiento_tipo_cambio: formState.movimiento_tipo_cambio
            })
        }

    }

    const handleChangeTypeCurrency = (event) => {
        const { FormScreen } = Forms
        const { formState, setFormState } = FormScreen

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_monto !== '' && formState.movimiento_tipo_cambio !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: formState.movimiento_monto,
                movimiento_moneda: value,
                movimiento_tipo_cambio: formState.movimiento_tipo_cambio
            })
        }

    }

    const handleChangeExchangeRate = (event) => {
        const { FormScreen } = Forms
        const { formState, setFormState } = FormScreen

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_monto !== '' && formState.movimiento_moneda !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: formState.movimiento_monto,
                movimiento_moneda: formState.movimiento_moneda,
                movimiento_tipo_cambio: value
            })
        }

    }

    const _calculateTotalQuetzalsAndDollars = async ({refSetFormState, movimiento_monto, movimiento_moneda, movimiento_tipo_cambio}) => {
        switch(movimiento_moneda){
            case 'QUETZAL':
                refSetFormState(prevState => ({
                    ...prevState,
                    movimiento_quetzales: parseFloat(movimiento_monto).toFixed(2) || '', // Valor predeterminado si es indefinido
                    movimiento_dolares: parseFloat(movimiento_monto / movimiento_tipo_cambio).toFixed(2) || '', // Valor predeterminado si es indefinido
                }))
            break
            case 'DOLAR':
                refSetFormState(prevState => ({
                    ...prevState,
                    movimiento_quetzales: parseFloat(movimiento_monto * movimiento_tipo_cambio).toFixed(2) || '', // Valor predeterminado si es indefinido
                    movimiento_dolares: parseFloat(movimiento_monto).toFixed(2) || '', // Valor predeterminado si es indefinido
                }))
            break
            default:
                console.log(`No se reconoce la selección: ${movimiento_moneda}`)
            break
        }
    }

    const handleClickDeletePaymentReception = async (idtransaction) => {
    
        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/legal-notarial/delete-lawyer-payment/${idtransaction}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllPaymentReception()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
            
        // const enlaceTemporal = document.createElement('a');
        // enlaceTemporal.href = openUrl;
        // enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
        // document.body.appendChild(enlaceTemporal);
        // enlaceTemporal.click();
        // document.body.removeChild(enlaceTemporal);

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
        
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
        
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
        
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');

            } catch (error) {
            console.error('Error al descargar la imagen', error);
            }

    }

    const handleClickReturnToVehicleReception = async (idlawyer) => {
        navigate(`/juridico/predio-judicial`)
    }
    
    const onSubmitForm = async (e, idlawyer) => {

        e.preventDefault()

        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

        // Determina si se hace un pago en "efectivo" para confirmar que se incluya información de la caja que recibirá el dinero
        if(formState.aprobacion_referencia_ach === ''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'No ha especificado el número de referencia / ACH'
            })
            return;
        }

        const _body = {
            idtransaction: formState.idtransaction,
            idlawyer: formState.idlawyer,
            aprobacion_referencia_ach: formState.aprobacion_referencia_ach,
            aprobacion_check: formState.aprobacion_check,
            user: user.username
        }

        
        // console.log('[useActions][onSubmitForm] _body ', _body)
        await marvarApi.post( `/legal-notarial/save-approval-bank-slip`, _body )
            .then(({ data }) => {

                alertMessage(data)
                onResetForm()
                handleClickFetchAllPaymentReception()
                handleClickHideForm()

            })
            .catch(error => {
                console.log('API ERROR: ', error)
                onResetForm()
                handleClickFetchAllPaymentReception()
                handleClickHideForm()
            })
    }
    

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllPaymentReception,
        handleClickFetchSpecificPaymentReception,
        handleChangeTypeTransaction,
        handleChangeAmount,
        handleChangeTypeCurrency,
        handleChangeExchangeRate,
        handleClickDeletePaymentReception,
        handleClickDownloadImage,
        handleClickReturnToVehicleReception,
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}